<mat-form-field subscriptSizing="dynamic" color="accent" class="lv-material-form-input"
                [hideRequiredMarker]="true" [floatLabel]="'auto'">
  <div class="lv-input-field"
       [ngClass]="{'lv-input-field-error': (isError() && !hasFocus) || showMeldung}">
      <mat-icon matPrefix class="lv-input-field-prefix-icon" *ngIf="prefixIcon" [svgIcon]="prefixIcon"></mat-icon>
    <span *ngIf="prefixIcon" matPrefix>&nbsp;</span>
    <input matInput [type]="type" [id]="id + '-input'" [(ngModel)]="model" name="lvInputField"
           [name]="name" [pattern]="pattern"
           [maxlength]="maxlength" [step]="stepsize" [lvAutoFocus]="autoFocus"
           (focus)="hasFocus = true" (blur)="onBlur()" [placeholder]="placeholder"
           [disabled]="disabled" [required]="isRequired"
           (click)="setElementSelected($event)"
           [autocomplete]="autocomplete"
           #lvInputField="ngModel" [errorStateMatcher]="stateMatcherFormInput">
    <div *ngIf="unit" matSuffix class="lv-input-field-unit">{{unit | translate}}</div>
    <ng-container *ngIf="suffixTemplate">
      <ng-container *ngTemplateOutlet="suffixTemplate"></ng-container>
    </ng-container>
    <mat-icon *ngIf="icon" [svgIcon]="icon"></mat-icon>
  </div>
  <mat-hint *ngIf="extendedHint" [innerHTML]="extendedHint"></mat-hint>
  <mat-error *ngIf="getError() as error" class="lv-control-error" [ngClass]="{'lv-show-untruncated-error': showUntruncatedError}" (click)="onErrorClick()">
    {{error}}
  </mat-error>
</mat-form-field>
